import { Reveal } from "./Reveal";

const steps = [
  { n: "01", title: "Apply", body: "Complete the carrier interest form and tell us about your business and equipment." },
  { n: "02", title: "Onboard", body: "Complete the carrier onboarding process and finalize your dispatch agreement." },
  { n: "03", title: "Set Preferences", body: "Tell us your desired lanes, home time, equipment information, and rate preferences." },
  { n: "04", title: "Get Moving", body: "We begin searching for opportunities while you remain in control of load acceptance." },
];

export const Process = () => (
  <section id="process" className="py-28 sm:py-36" data-testid="process-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal className="mb-16">
        <p className="font-mono text-[11px] uppercase tracking-[0.35em] text-neutral-500 mb-4">
          Process — How It Works
        </p>
        <h2 className="font-display font-bold uppercase tracking-tight leading-none text-3xl sm:text-5xl lg:text-6xl">
          Getting started
          <br />
          is simple.
        </h2>
      </Reveal>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-12">
        {steps.map((s, i) => (
          <Reveal key={s.n} delay={i * 0.12}>
            <div className="group border-t-2 border-white pt-6" data-testid={`process-step-${s.n}`}>
              <span className="font-display font-extrabold text-5xl sm:text-6xl text-white/15 group-hover:text-white/60 transition-colors duration-700">
                {s.n}
              </span>
              <h3 className="font-display font-bold uppercase tracking-tight text-xl mt-4 mb-2">
                {s.title}
              </h3>
              <p className="text-neutral-400 text-sm leading-relaxed">{s.body}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
